import { getUsernameForBarcode } from "../network/ScanBarcodeNetworkAPI";

export const getUsernameForBarcodeResource = async (barcode) => {
  return await getUsernameForBarcode(barcode);
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/resource/ScanBarcodeResource.js